<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="evento-registro" titulo="Evento / Confirmación Registro" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div id="banner" align="center" *ngIf="ctrl.cargando || ctrl.cargarDatosCatalogo || cargando">
  <div class="bloquear-azul">

  </div>
  <span class="tag is-primary is-large " style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
    <span class="icon">
      <i class="icon-worldwide fa-spin"></i>
    </span> &nbsp;
    <span>Cargando...</span>
  </span>
</div>

<div class="contenedor columns " style="height:100%; ">
  <div class="column is-2 is-hidden-mobile menu-izquierda">

    <!-- Menu izquierda del modulo enviroment" -->
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; height:100%;">

      <!-- formulario -->
      <form name="form">
        <section class="hero is-primary">
          <div class="hero-body">

            <!-- Opciones  -->
            <section class="hero is-primary">
              <div class="hero-head">
                <nav class="level">
                  <!-- Left side -->
                  <div class="level-left">
                    <div class="level-item">
                      <p class="title">
                        <span *ngIf="!ctrl.cargando" class="icon is-medium">
                          <i class="icon-checked"></i>
                        </span>
                        <span *ngIf="ctrl.cargando  || cargando" class="icon is-medium">
                          <i class="icon-worldwide fa-spin"></i>
                        </span>
                        <span class="icon is-medium">
                          <i class="icon-file"></i>
                        </span> Confirmación de Registro
                      </p>
                    </div>

                  </div>

                  <!-- Right side -->
                  <div class="level-right">

                    <a class="navbar-item is-primary tooltip" (click)="ctrl.regresar()">
                      <span class="icon fa-2x">
                        <i class="icon-back"> </i>
                      </span>
                      <span class="tooltiptext">Regresar</span>
                    </a>

                    <!-- <a class="navbar-item is-primary tooltip"  >
                      <span class="icon fa-2x">
                        <i class="icon-search "></i>
                      </span>
                      <span class="tooltiptext">Buscar</span>
                    </a> -->

                  </div>
                </nav>
              </div>
            </section>
          </div>
        </section>

        <a id="catalogos" (click)="ctrl.cargarCatalogo('eventos', 'evento');"></a> <!-- ctrl.cargarCatalogo('logos64', 'logos64', 'logo64'); -->
        <!-- <a id="logo64" (click)="asignarLogos(ctrl.logos64); "></a> -->

        <section class="section" style="overflow-y:auto; overflow-x:hidden; padding: 1rem; height: 86vh;">

          <div class="columns">
            <div class="column is-6">
              <label class="label">Evento:</label>
              <div class="control has-icons-left has-icons-right">
                <ng-select2 [disabled]="ctrl.eventos ? ctrl.eventos.length == 0 ? true : false : true" [options]="ctrl.optionSelect" (valueChanged)="seleccionarEvento($event); ctrl.cargarCatalogo('evento_registro', 'evento-registro?eventos_id='+evento);"
                  [data]="ctrl.eventos"></ng-select2>
              </div>
            </div>
            <div class="column is-6">
              <label class="label">Código de Preregistro o Nombre:</label>
              <div class="control is-expanded  has-icon has-icon-right">

                <ng-select2 [disabled]="ctrl.evento_registro ? ctrl.evento_registro.length == 0 ? true : false : true" [options]="ctrl.optionSelect" (valueChanged)="seleccionarEventoRegistro($event,ctrl.evento_registro,ctrl.eventos);"
                  [data]="ctrl.evento_registro"></ng-select2>
              </div>
            </div>

          </div>

          <div class="is-fullwidth has-text-centered" *ngIf="cargando">
            <br>
            <span class="tag is-primary is-large ">
              <span class="icon">
                <i class="icon-worldwide fa-spin"></i>
              </span> &nbsp;
              <span>Cargando...</span>
            </span>
          </div>

          <section *ngIf="dato?.id">
            <div class="content">
              <div class="box">

                <div class="content">
                  <p>
                    <strong>{{dato?.eventos?.nombre}}</strong> | <small class="text text-warning">{{dato?.eventos?.fecha_inicio}} - {{dato?.eventos?.fecha_termino}}</small>
                    <br>
                    {{dato?.eventos?.descripcion}}
                  </p>
                </div>

                <div class="content">
                    <p class="title is-3">{{dato?.apellido_paterno}} {{dato?.apellido_materno}} {{dato?.nombre}}</p>
                    <p class="subtitle is-5">P a r t i c i p a n t e</p>
                </div>

                <nav class="level">
                  <div class="level-item has-text-centered">
                    <div>
                      <p class="heading">CÓD. REG.</p>
                      <p class="title">{{dato?.codigo_prerregistro}}</p>
                    </div>
                  </div>
                  <div class="level-item has-text-centered">
                    <div>
                      <p class="heading">CÓD. CONF.</p>
                      <p class="title">{{dato?.codigo_confirmacion}}</p>
                    </div>
                  </div>
                  <div class="level-item has-text-centered">
                    <div>
                      <p class="heading">COSTO</p>
                      <p class="title">$ {{aPagar}}</p>
                    </div>
                  </div>
                  <div class="level-item has-text-centered">
                    <div>
                      <p class="heading">ABONO</p>
                      <p class="title">$ {{abonado}}</p>
                    </div>
                  </div>
                </nav>

                <div class="columns">
                  <div class="column is-4"> </div>
                  <div class="column is-4" *ngIf="dato?.codigo_confirmacion==null" style="height: 100px;">
                    <button class="button is-fullwidth is-fullheight is-success" [disabled]="aPagar>abonado || cargando" (click)="cargarDatos()" style="height: 100px;">
                      <span class="icon fa-2x has-text-white">
                        <i class="icon-checked"></i>
                      </span>
                      <span class="tooltiptext">Confirmar</span>
                    </button>
                  </div>
                  <div class="column is-4" *ngIf="dato?.codigo_confirmacion!=null" style="height: 100px;">
                    <button class="button is-fullwidth is-fullheight is-warning" type="button" (click)="imprimirConfirmado()" style="height: 100px;">
                      <span class="icon fa-2x has-text-white">
                        <i class="icon-printer"></i>
                      </span>
                      <span class="tooltiptext has-text-white">Ticket</span>
                    </button>
                  </div>
                  <div class="column is-4">  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
      </form>
    </div>
  </div>
</div>


